const queryStringMixin = {
    methods: {
      setQueryString() {
        this.$cookie.delete("query-string");
        let queryString = this.$route.fullPath.split("?")[1] || "";
        if (queryString !== "") {
          queryString = "?" + queryString;
          this.$cookie.set("query-string", queryString);
        }
      },
    },
  };
  
  export default queryStringMixin;
  